import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import * as moment from 'moment';
import { Buscar, BuscarData, buscarContratoPorDados, buscarContratoPorDadosCpf, buscarPorInscricao } from '../../services/contratos';
import { ProgressSpinner } from 'primereact/progressspinner';
import { BuscaAceite } from '../../services/assinaturas/index';
import './styles.css';
import { Calendar } from 'primereact/calendar';
import { ptBR } from '../../modulos/schemaDate';
import { statusBodyTemplate, statusItemTemplate } from './status';
import ActionBodyEditarTabela from './acoes';
import { vendedoresBodyTemplate, vendedoresItemTemplate } from './vendedores';
import {
    inscricaoBodyTemplate,
    nomeBodyTemplate,
    dataBodyTemplate,
    dataAceiteBodyTemplate,
    dataPagamentoBodyTemplate,
    CPFBodyTemplate,
    vendedorBody
} from './dadosTabela';
import { rowClass } from './rowClass';
import { showMessageAlert, showMessageError, showMessageSuccess } from '../others/toastr';
import { cpf } from '../../modulos/validation/cpf';
import { tratarStatus } from './tratarStatus';
import { decriptObjectOnLocalStorage, decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';

let aceiteData = false;
export default class ListaContratos extends Component {
    constructor() {
        super();
        this.permissao = decriptObjectOnLocalStorage('PERM');
        this.perfilPossivel = decriptoLocalStorage('perfilPossivel');
        this.state = {
            cod: decriptoLocalStorage('codigo_vendedor')?.decriptoValue,
            contratos: [],
            selectedRegistros: null,
            selectedStatus: '',
            selectedVend: null,
            selectedData: null,
            submit: false,
            loading: 'loading',
            customers: null,
            aceite: '',
            vendedores: [],
            mensagemFiltro: '',
            loadingData: false,
            firstItemToShow: 0,
            actualPage: 0,
            pageCount: 0,
            rows: 8,
            paginaDeBusca: 1,
            limitDeBusca: 1500,
            buscaInscricaoValue: '',
            loadingBuscaIncricao: false,
            dadosBuscaContrato: null
        };

        this.statuses = ['PRE', 'Ativo', 'Suspenso', 'Cancelado', 'Recusado'];
        this.rowClass = rowClass.bind(this);
        this.statusBodyTemplate = statusBodyTemplate.bind(this);
        this.vendedoresBodyTemplate = vendedoresBodyTemplate.bind(this);
        this.vendedoresItemTemplate = vendedoresItemTemplate.bind(this);
        this.onFilterVendChang = this.onFilterVendChang.bind(this);
    }

    componentDidUpdate() {
        if (this.state.actualPage !== 0 && this.state.actualPage !== this.state.prevPage && this.state.actualPage === this.state.pageCount - 1) {
            this.setState({ prevPage: this.state.actualPage });
            this.buscar();
        }
    }

    componentDidMount() {
        this.setState({
            loading: 'nada',
            submit: true
        });
        this.setState({ cod: decriptoLocalStorage('codigo_vendedor')?.decriptoValue });
        this.aceite();

        if (this.permissao == 1) {
            if (this.perfilPossivel == 1) {
                this.setState({
                    mensagemFiltro:
                        'Atenção! Você está no perfil vendedor. A listagem dos contratos refere-se somente as suas vendas.'
                });
            }
        } else {
            this.setState({
                mensagemFiltro:
                    ' A listagem dos contratos refere-se as vendas de toda sua equipe.'
            });
        }
    }

    buscaContratos = async dadosBusca => {
        function tratarCpf(cpf) {
            cpf = cpf.replaceAll('_', '');
            cpf = cpf.replaceAll('.', '');
            cpf = cpf.replaceAll('-', '');

            return cpf;
        }

        this.setState({ loadingBuscaIncricao: true });

        let errorTitle = 'Erro de comunicação com o servidor';
        let errorMessage = 'dados não encontrados!';
        let res = [];

        try {
            if (!dadosBusca && this.permissao === 12) {
                return;
            }

            if (!dadosBusca && this.permissao !== 12) {
                return await this.buscar();
            }

            if (!isNaN(+dadosBusca) && dadosBusca.length >= 11 || isNaN(+dadosBusca) && (dadosBusca.includes('.') || dadosBusca.includes('-'))) {
                const cpf = tratarCpf(dadosBusca.trim());

                res = await buscarContratoPorDadosCpf(this.state.cod, this.permissao, cpf);
            }

            else if (!isNaN(+dadosBusca)) {
                res = await buscarPorInscricao(this.state.cod, this.permissao, dadosBusca.trim());
            }

            else if (isNaN(+dadosBusca)) {
                res = await buscarContratoPorDados(this.state.cod, this.permissao, dadosBusca.trim());
            }

            const contratoEncontrado = res.data;
            const statusDaBusca = res.response?.status;

            if (statusDaBusca === 403) {
                this.setState({ paginaDeBusca: 1 });
                errorTitle = 'Erro';
                errorMessage = `Voce não tem acesso ao contrato ${dadosBusca}`;

                throw new Error(errorMessage);
            }

            if (!contratoEncontrado) {
                errorTitle = 'Erro';
                errorMessage = 'Contrato não encontrado';

                throw new Error(errorMessage);
            }

            this.setState({ contratos: [] });

            if (!contratoEncontrado.Inscricaos || contratoEncontrado.Inscricaos[0] === undefined) {
                contratoEncontrado.Inscricaos = [{ Pagamento: null }];
            }

            if (!contratoEncontrado.Vendedore) {
                contratoEncontrado.Vendedore = { Nome: contratoEncontrado['Vendedore.Nome'] };
            }

            if (!contratoEncontrado.SignatureOrderLink) {
                contratoEncontrado.SignatureOrderLink = { StatusLink: contratoEncontrado['SignatureOrderLink.StatusLink'] };
            }

            this.setState({ paginaDeBusca: 1 });
            this.loadContratos(contratoEncontrado);

            return;
        } catch (err) {
            showMessageAlert(
                errorTitle,
                errorMessage
            );
        } finally {
            this.setState({ loadingBuscaIncricao: false });
        }
    };

    buscaPorCpf = async e => {
        const cpfBusca = e.target.value;

        try {
            let contratos = [];
            const query = `cpf=${cpfBusca}`;

            this.setState({ loadingData: true });
            this.setState({ contratos: [] });

            if (cpf(cpfBusca) === true) {
                contratos = await Buscar(this.state.cod, this.permissao, query);
            }

            if (cpfBusca === '') {
                contratos = await Buscar(this.state.cod, this.permissao);
            }

            if (contratos.length > 0) {
                this.loadContratos(contratos);
                this.setState({ loadingData: false });
            } else {
                this.setState({ loadingData: false });
            }
        } catch (err) {
            showMessageAlert(
                'Erro de comunicação com o servidor',
                'dados não encontrados!'
            );
            this.setState({ globalFilter: cpfBusca });
            this.setState({ loadingData: false });
        }
    };

    aceite = () => {
        BuscaAceite(this.state.cod)
            .then(response => {
                this.setState({ aceite: response });
                this.buscar();
            })
            .catch(erro => {
            });
    };

    buscar = async () => {
        try {
            if (this.permissao === 12) {
                showMessageAlert(
                    'Usuário de cobrança',
                    'digite a inscrição para encontrar contratos!'
                );

                return;
            }

            const query = `pagina=${this.state.paginaDeBusca}&itens=${this.state.limitDeBusca}`;

            const response = await Buscar(this.state.cod, this.permissao, query);

            this.loadContratos(response);
            this.setState({ paginaDeBusca: this.state.paginaDeBusca + 1 });
        } catch (error) {
            showMessageError('Não foi possível fazer a busca', 'tente novamente!');
        } finally {
            this.setState({
                loading: 'loading',
                submit: false
            });
        }
    };

    onStatusFilterChange = event => {
        this.dt.filter(event.value, 'Status', 'equals');
        this.setState({ selectedStatus: event.value });
    };

    onFilterVendChang = e => {
        this.dt.filter(e.value, 'Vendedore.Nome', 'equals');
        this.setState({ selectedVend: e.value });
    };

    exportCSV = () => {
        this.dt.exportCSV();
    };

    renderStatusFilter() {
        return (
            <Dropdown
                value={this.state.selectedStatus}
                options={this.statuses}
                onChange={this.onStatusFilterChange}
                itemTemplate={statusItemTemplate}
                showClear={true}
                placeholder="Selecione o Status"
                className="p-column-filter"
            />
        );
    }

    renderFilterVend() {
        return (
            <Dropdown
                value={this.state.selectedVend}
                options={this.state.vendedores}
                onChange={this.onFilterVendChang}
                itemTemplate={this.vendedoresItemTemplate}
                placeholder="Vendedor"
                showClear={true}
                className="p-column-filter"
            />
        );
    }

    loadContratos(contratos) {
        try {
            if (contratos.length > 0) {
                for (let i = 0; i < contratos.length; i++) {
                    this.state.aceite.forEach(element => {
                        if (contratos[i]['Inscricao'] === element.Inscricao) {
                            contratos[i].aceite = moment(element.CreateAt)
                                .add(3, 'hours')
                                .format('DD-MM-YYYY');
                        }
                    });

                    if (contratos[i].Inscricaos[0].Pagamento) {
                        contratos[i].DataPagamento = moment(
                            contratos[i].Inscricaos[0].Pagamento
                        )
                            .add(3, 'hours')
                            .format('DD/MM/YYYY');
                        aceiteData = true;
                    } else {
                        contratos[i].DataPagamento = 'Não identificado';
                    }

                    if (Array.isArray(contratos[i].SignatureOrderLink)) {
                        const linkAceito = contratos[i].SignatureOrderLink.find(link => link.StatusLink === 2);

                        contratos[i].SignatureOrderLink = linkAceito ? linkAceito : contratos[i].SignatureOrderLink.sort((a, b) => (!new Date(a.UpdateAt) && !new Date(b.UpdateAt)) ? Date(b.CreateAt) - new Date(a.CreateAt) : new Date(b.UpdateAt) - new Date(a.UpdateAt))[0];
                    }

                    if (contratos[i].Grupo != null) {
                        tratarStatus(contratos);
                    }
                }

                this.state.paginaDeBusca === 1 ? this.setState({ contratos }) : this.setState({ contratos: [...this.state.contratos, ...contratos] });

                this.setState({
                    loading: 'loading',
                    submit: false
                });

                const dataAPI = this.state.contratos;
                const dataNomeVend = dataAPI.map(item => {
                    if (item.Vendedore && item.Vendedore.Nome) {
                        return item.Vendedore.Nome;
                    }
                });
                const arrUnique = new Set(dataNomeVend);

                arrUnique.delete(undefined);
                this.setState({ vendedores: [...arrUnique] });
            } else {
                throw new Error('Nenhum contrato encontrado');
            }
        } catch (error) {
            showMessageError('Nenhum contrato encontrado', 'tente novamente!');
        } finally {
            this.setState({
                loading: 'loading',
                submit: false
            });
        }
    }

    renderHeader() {
        return (
            <div>
                <div
                    className="p-grid p-fluid DatatableHeader"
                >
                    <div className="p-col-3 p-md-3 buscaPorInscricao">
                        {this.state.loadingBuscaIncricao && <i className="pi pi-spin pi-spinner loadingBuscaPorInscricao" />}
                        <InputText
                            type="search"
                            icon='pi pi-spinner'
                            placeholder="Buscar por termo, ex: nº da Inscrição"
                            onChange={e => this.setState({ dadosBuscaContrato: e.target.value })}
                        />
                    </div>
                    {this.permissao === '12' && (
                        <div className="p-col-3 p-md-3">
                            <InputText
                                type="search"
                                onChange={this.buscaPorCpf}
                                placeholder="Buscar por CPF"
                            />
                        </div>
                    )}
                    <div className='p-col-2 p-md-2'>
                        <Button
                            className='p-button-raised p-button-secondary botaoBuscarContratos'
                            icon='pi pi-search'
                            label='Buscar'
                            onClick={e => {
                                const buscaContratoValue = this.state.dadosBuscaContrato;

                                this.buscaContratos(buscaContratoValue);
                            }}>
                        </Button>
                    </div>
                    <div className="p-col-6 p-md-3">
                        <Calendar
                            className="input-buscarData"
                            dateFormat="mm/yy"
                            view="month"
                            locale={ptBR}
                            type="search"
                            placeholder=" Buscar por data (Mês/Ano)"
                            onChange={e => this.queryStringEx(e)}
                            showIcon={true}
                            showButtonBar={true}
                        />
                    </div>
                    <div className="p-col-3 p-md-3">
                        <Button
                            label="Exporta CSV"
                            icon="pi pi-file-excel"
                            color="secondary"
                            className="p-button-raised p-button-secondary buttonExportCsv"
                            onClick={this.exportCSV}
                        />
                    </div>
                </div>
                <span
                    style={{
                        marginTop: 2,
                        color: '#001781',
                        fontSize: 16,
                        textAlign: 'center'
                    }}
                >
                    {this.state.mensagemFiltro}
                </span>
            </div>
        );
    }

    async queryStringEx(e) {
        try {
            this.setState({ loadingData: true });

            const dataFormatada = moment(e.target.value).format('MM/YYYY');
            const mes = dataFormatada.substring(0, 2);
            const ano = dataFormatada.substring(3, 7);

            if (e && e.target && !e.target.value) { return await this.buscar(); }

            //Constroi data somente se houver mês e ano
            const valor = ano && mes ? `${ano}-${mes}` : null;

            //Valida se possui a data montada
            if (!valor || (valor && ano && ano.length < 4)) {
                throw new Error('Formato de data incorreto');
            }

            const response = await BuscarData(this.state.cod, valor, this.permissao);

            if (response && response.length > 0) {
                for (let i = 0; i < response.length; i++) {
                    this.state.aceite.forEach(element => {
                        if (response[i]['Inscricao'] === element.Inscricao) {
                            response[i].Aceite = moment(element.CreateAt)
                                .add(3, 'hours')
                                .format('DD-MM-YYYY');
                        }
                    });

                    if (!response[i].Aceite) {
                        response[i].Aceite = 'Não Encontrado';
                    }

                    if (
                        response[i].Inscricaos &&
                        response[i].Inscricaos.Pagamento
                    ) {
                        response[i].DataPagamento = moment(
                            response[i].Inscricaos.Pagamento
                        )
                            .add(3, 'hours')
                            .format('DD/MM/YYYY');
                        aceiteData = true;
                    } else {
                        response[i].DataPagamento = 'Não identificado';
                    }                    

                    response[i].Data = moment(response[i].Data, ['DD-MM-YYYY'])
                        .add(3, 'hours')
                        .format('DD-MM-YYYY');
                    tratarStatus(response);
                }

                this.setState({ contratos: response });
                showMessageSuccess(
                    'Busca Realizada com sucesso!',
                    ''
                );
            } else {
                throw new Error('Nenhum contrato encontrado para essa data');
            }
        } catch (error) {
            showMessageError(error.message || 'Não foi possível fazer a busca', 'tente novamente!');
        } finally {
            this.setState({ loadingData: false });
        }
    }

    render() {
        const header = this.renderHeader();
        const statusFilter = this.renderStatusFilter();
        const VendedorFilter = this.renderFilterVend();

        return (
            <div>
                <div className={this.state.loading}>
                    <ProgressSpinner
                        style={{
                            width: '300px',
                            height: '150px',
                            display: 'flex',
                            marginTop: '8%'
                        }}
                        strokeWidth="1"
                        fill="#EEEEEE"
                        animationDuration=".5s"
                    />
                </div>
                {this.state.submit !== true && this.state.contratos && (
                    <div className="datatable-responsive-demo">
                        <div className="card">
                            <DataTable
                                csvSeparator=";"
                                value={this.state.contratos}
                                header={header}
                                ref={el => (this.dt = el)}
                                className="p-datatable-responsive-demo"
                                dataKey="id"
                                globalFilter={this.state.globalFilter}
                                selection={this.state.selectedRegistros}
                                onSelectionChange={e =>
                                    this.setState({ selectedRegistros: e.value })
                                }
                                onPage={e => {
                                    const actualPage = this.state.actualPage;

                                    this.setState({
                                        firstItemToShow: e.first,
                                        actualPage: e.page,
                                        pageCount: e.pageCount,
                                        rows: e.rows,
                                        prevPage: actualPage
                                    });
                                }}
                                first={this.state.firstItemToShow}
                                paginator
                                rows={this.state.rows}
                                emptyMessage="Nenhum resultado encontrado"
                                currentPageReportTemplate="Mostrando {first} de {last} em {totalRecords}  Registros encontrados"
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                rowsPerPageOptions={[8, 25, 50]}
                                rowClassName={rowClass}
                                loading={this.state.loadingData}
                            >
                                <Column
                                    field="Inscricao"
                                    header="Inscrição"
                                    headerStyle={{
                                        width: '7em',
                                        textAlign: 'center'
                                    }}
                                    body={inscricaoBodyTemplate}
                                />
                                <Column
                                    field="Nome"
                                    header="Nome"
                                    body={nomeBodyTemplate}
                                />
                                <Column
                                    field="Data"
                                    header="Data Venda"
                                    body={dataBodyTemplate}
                                />
                                <Column
                                    field="aceite"
                                    header="Data Aceite"
                                    body={dataAceiteBodyTemplate}
                                />
                                <Column
                                    field="DataPagamento"
                                    header="Data Pagamento"
                                    body={dataPagamentoBodyTemplate}
                                />
                                <Column
                                    field="Vendedore.Nome"
                                    header="Vendedor"
                                    body={vendedorBody}
                                    sortable
                                    filter
                                    filterElement={VendedorFilter}
                                />
                                <Column
                                    className="Status"
                                    field="Status"
                                    header="Status"
                                    body={statusBodyTemplate}
                                    sortable
                                    filter
                                    filterElement={statusFilter}
                                />
                                <Column
                                    field="CPF"
                                    header="CPF"
                                    body={CPFBodyTemplate}
                                />
                                <Column
                                    exportable={false}
                                    field="Status"
                                    body={ActionBodyEditarTabela}
                                    header="Ações"
                                    className="Acoes"
                                >
                                    <button>Editar</button>
                                </Column>
                            </DataTable>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
